<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { KsButton } from '@aschehoug/kloss'
import SettingsDrawer from './SettingsDrawer.vue'

const { t } = useI18n()
const drawerOpen = ref(false)
</script>

<template>
  <KsButton
    v-ks-tooltip="t('settings.title')"
    variant="secondary"
    shape="round"
    size="large"
    iconLeft="cog"
    @click.prevent="drawerOpen = !drawerOpen"
  >
    <SettingsDrawer
      :open="drawerOpen"
      @close="drawerOpen = false"
    />
  </KsButton>
</template>
